import { action, makeObservable, observable } from 'mobx';
import { DEFAULT_AUTO_BET_COUNT } from '../core/constants/autoBetContants';

class AutoBetStore {
  isAutoBetOn = false;

  autoBetCount = DEFAULT_AUTO_BET_COUNT;

  isAutoBetStart = false;

  constructor() {
    makeObservable(this, {
      isAutoBetOn: observable,
      autoBetCount: observable,
      isAutoBetStart: observable,
      setIsAutoBetOn: action.bound,
      setAutoBetCount: action.bound,
      resetAutoBetState: action.bound,
      setIsAutoBetStart: action.bound,
    });
  }

  setIsAutoBetStart(bool) {
    this.isAutoBetStart = bool;
  }

  setAutoBetCount(autoBetCount) {
    this.autoBetCount = autoBetCount;
  }

  setIsAutoBetOn(isAutoBetOn) {
    this.isAutoBetOn = isAutoBetOn;
  }

  resetAutoBetState() {
    this.setIsAutoBetStart(false);
    this.setIsAutoBetOn(false);
    this.setAutoBetCount(DEFAULT_AUTO_BET_COUNT);
  }
}

export const autoBetStore = new AutoBetStore();
